// extracted by mini-css-extract-plugin
export default {"add":"control_add__49vxO","tooltip":"control_tooltip__dj+Fk"};